export const NameAZ = "A -> Z"
export const NameZA = "Z -> A"
export const NewOld = "New -> Old"
export const OldNew = "Old -> New"
export const CloudGpxSortDirections = [NameAZ, NameZA, NewOld, OldNew]